(function () {
  function initQuantityControls(scope) {
    (scope || document).querySelectorAll('[data-quantity-control]').forEach(function (control) {
      if (control.dataset.quantityReady === 'true') return;
      control.dataset.quantityReady = 'true';

      var input = control.querySelector('input');
      var minus = control.querySelector('[data-quantity-minus]');
      var plus = control.querySelector('[data-quantity-plus]');
      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function () {
          var min = Number(input.min || 0);
          input.value = Math.max(min, Number(input.value || 0) - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          input.value = Number(input.value || 0) + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.productReady === 'true') return;
    root.dataset.productReady = 'true';

    var select = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    var availability = root.querySelector('[data-product-availability]');
    var sku = root.querySelector('[data-product-sku]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    var mobilePrice = root.querySelector('[data-mobile-buy-price]');
    var mobileButton = root.querySelector('[data-mobile-buy-submit]');
    var form = root.querySelector('[data-product-form]');
    var thumbs = root.querySelectorAll('[data-media-target]');
    var zoomButtons = root.querySelectorAll('[data-media-zoom]');
    var mediaDialog = root.querySelector('[data-media-dialog]');
    var mediaDialogImage = mediaDialog ? mediaDialog.querySelector('[data-media-dialog-image]') : null;
    var mediaDialogClose = mediaDialog ? mediaDialog.querySelector('[data-media-dialog-close]') : null;

    function showMedia(mediaId) {
      if (!mediaId) return;

      root.querySelectorAll('[data-media-id]').forEach(function (media) {
        media.classList.toggle('is-active', String(media.dataset.mediaId) === String(mediaId));
      });

      thumbs.forEach(function (thumb) {
        var active = String(thumb.dataset.mediaTarget) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.mediaTarget);
      });
    });

    zoomButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!mediaDialog || !mediaDialogImage || !button.dataset.zoomSrc) return;
        mediaDialogImage.src = button.dataset.zoomSrc;
        mediaDialogImage.alt = button.dataset.zoomAlt || '';
        mediaDialogImage.hidden = false;
        if (typeof mediaDialog.showModal === 'function') mediaDialog.showModal();
      });
    });

    if (mediaDialogClose && mediaDialog) {
      mediaDialogClose.addEventListener('click', function () { mediaDialog.close(); });
      mediaDialog.addEventListener('click', function (event) {
        if (event.target === mediaDialog) mediaDialog.close();
      });
      mediaDialog.addEventListener('close', function () {
        if (mediaDialogImage) {
          mediaDialogImage.hidden = true;
          mediaDialogImage.removeAttribute('src');
        }
      });
    }

    if (select && select.tagName === 'SELECT') {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var available = option.dataset.available === 'true';
        var currentPrice = option.dataset.price || '';
        var compare = option.dataset.comparePrice || '';

        if (price) {
          price.innerHTML = compare
            ? '<span class="lw-pdp__price-sale">' + currentPrice + '</span> <s>' + compare + '</s>'
            : currentPrice;
        }

        if (mobilePrice) mobilePrice.textContent = currentPrice;
        if (sku) sku.textContent = option.dataset.sku || '';

        if (availability) {
          availability.classList.toggle('is-in-stock', available);
          availability.classList.toggle('is-out-of-stock', !available);
          availability.innerHTML = '<span aria-hidden="true"></span>' + (available ? 'Available to order' : 'Currently unavailable');
        }

        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';

        if (mobileButton) {
          mobileButton.disabled = !available;
          mobileButton.textContent = available ? 'Add to cart' : 'Sold out';
        }

        showMedia(option.dataset.mediaId);

        try {
          var currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', currentUrl.toString());
        } catch (error) {}
      });
    }

    if (mobileButton && form) {
      mobileButton.addEventListener('click', function () {
        if (!mobileButton.disabled) form.requestSubmit();
      });
    }

    initQuantityControls(root);
  }

  function initPredictiveSearch(scope) {
    (scope || document).querySelectorAll('[data-predictive-search-form]').forEach(function (form) {
      if (form.dataset.predictiveReady === 'true') return;
      form.dataset.predictiveReady = 'true';

      var input = form.querySelector('[data-predictive-search-input]');
      var results = form.nextElementSibling && form.nextElementSibling.matches('[data-predictive-search]')
        ? form.nextElementSibling
        : null;
      if (!input || !results) return;

      var timer;
      var controller;

      function closeResults() {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function loadResults() {
        var term = input.value.trim();
        if (term.length < 2) {
          closeResults();
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        var url = rootPath + 'search/suggest?q=' + encodeURIComponent(term)
          + '&resources[type]=product,collection'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=last'
          + '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search unavailable');
            return response.text();
          })
          .then(function (text) {
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var section = holder.querySelector('#shopify-section-predictive-search');
            var content = section ? section.innerHTML.trim() : '';

            if (!content) {
              closeResults();
              return;
            }

            results.innerHTML = content;
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') closeResults();
          });
      }

      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(loadResults, 180);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML.trim()) {
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeResults();
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target) && !results.contains(event.target)) closeResults();
      });
    });
  }

  function initFilters(scope) {
    (scope || document).querySelectorAll('[data-filter-toggle]').forEach(function (button) {
      if (button.dataset.filterReady === 'true') return;
      button.dataset.filterReady = 'true';

      var panelId = button.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      var close = panel.querySelector('[data-filter-close]');

      function setOpen(open) {
        panel.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('lw-filters-open', open);
      }

      button.addEventListener('click', function () { setOpen(true); });
      if (close) close.addEventListener('click', function () { setOpen(false); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setOpen(false);
      });
    });
  }

  function initRecommendations(scope) {
    (scope || document).querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsReady === 'true') return;
      section.dataset.recommendationsReady = 'true';
      if (!section.dataset.url) return;

      var load = function () {
        fetch(section.dataset.url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var replacement = holder.querySelector('[data-product-recommendations]');
            if (replacement && replacement.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
          })
          .catch(function () {});
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '0px 0px 350px 0px' });
        observer.observe(section);
      } else {
        load();
      }
    });
  }

  var VEHICLE_STORAGE_KEY = 'lakewood:selected-vehicle:v1';

  function cleanVehicleValue(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getSavedVehicle() {
    try {
      var raw = window.localStorage.getItem(VEHICLE_STORAGE_KEY);
      if (!raw) return null;
      var vehicle = JSON.parse(raw);
      if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return null;
      return vehicle;
    } catch (error) {
      return null;
    }
  }

  function getVehicleLabel(vehicle) {
    if (!vehicle) return '';
    return [vehicle.year, vehicle.make, vehicle.model, vehicle.submodel].filter(Boolean).join(' ');
  }

  function getSelectedText(select) {
    if (!select || !select.options || select.selectedIndex < 0) return '';
    var option = select.options[select.selectedIndex];
    return cleanVehicleValue(option && (option.textContent || option.value));
  }

  function inferVehicleFromScope(scope) {
    if (!scope || !scope.querySelectorAll) return null;
    var selects = Array.prototype.slice.call(scope.querySelectorAll('select'));
    if (selects.length < 3) return null;

    var fields = { year: null, make: null, model: null, submodel: null };
    selects.forEach(function (select) {
      var id = cleanVehicleValue(select.id).toLowerCase();
      var name = cleanVehicleValue(select.name).toLowerCase();
      var aria = cleanVehicleValue(select.getAttribute('aria-label')).toLowerCase();
      var label = '';
      if (select.id) {
        var escapedId = window.CSS && window.CSS.escape ? window.CSS.escape(select.id) : select.id.replace(/([\.\#\[\]\:\s])/g, '\\$1');
        var labelNode = scope.querySelector('label[for="' + escapedId + '"]');
        if (labelNode) label = cleanVehicleValue(labelNode.textContent).toLowerCase();
      }
      var descriptor = [id, name, aria, label].join(' ');
      if (!fields.year && descriptor.indexOf('year') !== -1) fields.year = select;
      else if (!fields.make && descriptor.indexOf('make') !== -1) fields.make = select;
      else if (!fields.model && descriptor.indexOf('model') !== -1 && descriptor.indexOf('submodel') === -1) fields.model = select;
      else if (!fields.submodel && (descriptor.indexOf('submodel') !== -1 || descriptor.indexOf('trim') !== -1)) fields.submodel = select;
    });

    if (!fields.year) {
      fields.year = selects.find(function (select) { return /^\d{4}$/.test(cleanVehicleValue(select.value || getSelectedText(select))); }) || null;
    }

    if (fields.year && (!fields.make || !fields.model)) {
      var yearIndex = selects.indexOf(fields.year);
      if (!fields.make && yearIndex > -1) fields.make = selects[yearIndex + 1] || null;
      if (!fields.model && yearIndex > -1) fields.model = selects[yearIndex + 2] || null;
      if (!fields.submodel && yearIndex > -1) fields.submodel = selects[yearIndex + 3] || null;
    }

    if (!fields.year || !fields.make || !fields.model) return null;
    var year = cleanVehicleValue(fields.year.value || getSelectedText(fields.year));
    var make = getSelectedText(fields.make);
    var model = getSelectedText(fields.model);
    var submodel = fields.submodel ? getSelectedText(fields.submodel) : '';

    if (!/^\d{4}$/.test(year)) return null;
    if (!make || !model) return null;
    if (/select|choose|make/i.test(make)) return null;
    if (/select|choose|model/i.test(model)) return null;
    if (/select|choose|submodel|trim/i.test(submodel)) submodel = '';

    return { year: year, make: make, model: model, submodel: submodel };
  }

  function vehicleFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var vehicle = { year: '', make: '', model: '', submodel: '' };
      params.forEach(function (value, key) {
        var normalized = key.toLowerCase();
        if (!vehicle.year && normalized.indexOf('year') !== -1 && /^\d{4}$/.test(value)) vehicle.year = value;
        if (!vehicle.make && normalized.indexOf('make') !== -1) vehicle.make = cleanVehicleValue(value);
        if (!vehicle.model && normalized.indexOf('model') !== -1 && normalized.indexOf('submodel') === -1) vehicle.model = cleanVehicleValue(value);
        if (!vehicle.submodel && (normalized.indexOf('submodel') !== -1 || normalized.indexOf('trim') !== -1)) vehicle.submodel = cleanVehicleValue(value);
      });
      return vehicle.year && vehicle.make && vehicle.model ? vehicle : null;
    } catch (error) {
      return null;
    }
  }

  function updateVehicleContexts(vehicle) {
    var label = vehicle ? getVehicleLabel(vehicle) : '';
    var header = document.querySelector('[data-lw-header]');
    var pageType = header ? header.dataset.pageType : '';
    var selectedCopy = pageType === 'product'
      ? 'Confirm fit for this exact product'
      : 'Use this truck to show compatible products';

    document.querySelectorAll('[data-lw-vehicle-label]').forEach(function (node) {
      node.textContent = label || 'Select your vehicle';
    });
    document.querySelectorAll('[data-lw-vehicle-fit-copy]').forEach(function (node) {
      node.textContent = vehicle ? selectedCopy : 'See parts built for your truck';
    });
    document.querySelectorAll('[data-lw-vehicle-context]').forEach(function (node) {
      node.classList.toggle('has-vehicle', Boolean(vehicle));
      if (vehicle) node.setAttribute('aria-label', 'Shopping for ' + label + '. Change vehicle.');
      else node.setAttribute('aria-label', 'Select your vehicle.');
    });

    document.querySelectorAll('[data-predictive-search-input]').forEach(function (input) {
      var fallback = input.getAttribute('data-default-placeholder') || 'Search truck parts and accessories';
      input.setAttribute('placeholder', vehicle ? 'Search ' + label + ' parts' : fallback);
    });

    document.querySelectorAll('[data-lw-vehicle-results-banner]').forEach(function (banner) {
      banner.classList.toggle('has-vehicle', Boolean(vehicle));
      var vehicleNode = banner.querySelector('[data-lw-results-vehicle]');
      var copyNode = banner.querySelector('[data-lw-results-copy]');
      if (vehicleNode) vehicleNode.textContent = label || 'Select your truck';
      if (copyNode) copyNode.textContent = vehicle
        ? 'Your saved truck carries into organized product families and fitment results.'
        : 'Choose a year, make, and model to narrow compatible parts.';
    });

    var productNotice = document.querySelector('[data-lw-product-fitment]');
    if (productNotice) {
      var title = productNotice.querySelector('[data-lw-product-fitment-title]');
      var copy = productNotice.querySelector('[data-lw-product-fitment-copy]');
      if (title) title.textContent = vehicle ? 'Shopping for ' + label : 'Make sure it fits before you order.';
      if (copy) copy.textContent = vehicle
        ? 'Your truck is saved. Use the fitment widget on this page to confirm this exact part before ordering.'
        : 'Select your vehicle or use the fitment details on this page to confirm the exact application.';
    }
  }

  function saveVehicle(vehicle) {
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return;
    try { window.localStorage.setItem(VEHICLE_STORAGE_KEY, JSON.stringify(vehicle)); } catch (error) {}
    updateVehicleContexts(vehicle);
    document.dispatchEvent(new CustomEvent('lakewood:vehiclechange', { detail: vehicle }));
  }

  function scanVehicleSelectors(scope) {
    var roots = scope && scope.querySelectorAll ? scope : document;
    var selectors = [
      '[data-fitment-selector]',
      '.lw-fitment-hub__app',
      '.lw-collection-fitment__app',
      '.lw-brand-hub__fitment-app',
      '[id^="shopify-block"]',
      '[class*="easysearch"]',
      '[class*="EasySearch"]',
      '[class*="ymm"]',
      '[class*="YMM"]'
    ];
    var candidates = [];
    selectors.forEach(function (selector) {
      try {
        roots.querySelectorAll(selector).forEach(function (node) { candidates.push(node); });
      } catch (error) {}
    });
    if (scope && scope.matches) candidates.unshift(scope);

    for (var i = 0; i < candidates.length; i += 1) {
      var vehicle = inferVehicleFromScope(candidates[i]);
      if (vehicle) {
        saveVehicle(vehicle);
        return vehicle;
      }
    }
    return null;
  }

  function initVehicleContext(scope) {
    if (document.documentElement.dataset.lwVehicleContextReady === 'true') {
      updateVehicleContexts(getSavedVehicle());
      return;
    }
    document.documentElement.dataset.lwVehicleContextReady = 'true';

    var fromUrl = vehicleFromUrl();
    if (fromUrl) saveVehicle(fromUrl);
    else updateVehicleContexts(getSavedVehicle());

    document.addEventListener('change', function (event) {
      if (!event.target || event.target.tagName !== 'SELECT') return;
      window.setTimeout(function () {
        var source = event.target.closest('[data-fitment-selector], .lw-fitment-hub__app, .lw-collection-fitment__app, .lw-brand-hub__fitment-app, [id^="shopify-block"], form, section');
        scanVehicleSelectors(source || document);
      }, 60);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('button, input[type="submit"], a') : null;
      if (!button) return;
      var text = cleanVehicleValue(button.textContent || button.value).toLowerCase();
      if (text.indexOf('add to garage') === -1 && text !== 'search' && text.indexOf('shop now') === -1) return;
      window.setTimeout(function () {
        var source = button.closest('[id^="shopify-block"], .lw-fitment-hub__app, .lw-collection-fitment__app, .lw-brand-hub__fitment-app, form, section');
        scanVehicleSelectors(source || document);
      }, 120);
    }, true);

    window.addEventListener('storage', function (event) {
      if (event.key === VEHICLE_STORAGE_KEY) updateVehicleContexts(getSavedVehicle());
    });
    document.addEventListener('lakewood:vehiclechange', function () {
      updateVehicleContexts(getSavedVehicle());
    });

    [500, 1600, 3200].forEach(function (delay) {
      window.setTimeout(function () {
        if (!getSavedVehicle()) scanVehicleSelectors(document);
        updateVehicleContexts(getSavedVehicle());
      }, delay);
    });

    var observer = new MutationObserver(function () {
      if (!getSavedVehicle()) scanVehicleSelectors(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initLegacyVehicleForms(scope) {
    (scope || document).querySelectorAll('[data-vehicle-form]').forEach(function (form) {
      if (form.dataset.vehicleReady === 'true') return;
      form.dataset.vehicleReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var values = Array.prototype.slice.call(form.querySelectorAll('select')).map(function (select) {
          return select.value;
        }).filter(Boolean);
        if (values.length) window.location.href = '/search?q=' + encodeURIComponent(values.join(' '));
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-lw-product]').forEach(initProduct);
    initQuantityControls(root);
    initPredictiveSearch(root);
    initFilters(root);
    initRecommendations(root);
    initLegacyVehicleForms(root);
    initVehicleContext(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
